import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import * as React from 'react';
import { ApSchedulerBuildStage } from '../../../../../sic-lib/enums/ApSchedulerBuildStage';
import { useAppSelector } from '../../../../../store/hooks';
import { DialogId } from '../MenuResetApScheduler';

interface Props {
    menuId: string;
    anchorEl: HTMLElement | null;
    onSelectHandler: (event: React.MouseEvent<HTMLElement>) => void;
    onCloseHandler: () => void;
}

export default function MenuResetApSchedulerRaw({
    menuId,
    anchorEl,
    onSelectHandler,
    onCloseHandler,
}: Props) {
    const apContacts = useAppSelector(state => state.communicator?.contacts || []);
    const apTemplate = useAppSelector(state => state.communicator?.template || null);
    const buildStage = useAppSelector(
        state => state.communicator?.buildStage || ApSchedulerBuildStage.edit,
    );

    return (
        <Menu id={menuId} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onCloseHandler}>
            <MenuItem
                data-dialog-id={DialogId.contacts}
                disabled={apContacts.length < 1 || buildStage !== ApSchedulerBuildStage.edit}
                onClick={onSelectHandler}
            >
                Reset Contacts
            </MenuItem>
            <MenuItem
                data-dialog-id={DialogId.template}
                disabled={apTemplate === null || buildStage !== ApSchedulerBuildStage.edit}
                onClick={onSelectHandler}
            >
                Reset Template
            </MenuItem>
            <Divider />
            <MenuItem
                data-dialog-id={DialogId.all}
                disabled={apContacts.length < 1 && apTemplate === null}
                onClick={onSelectHandler}
            >
                Reset All
            </MenuItem>
        </Menu>
    );
}
